import { DefaultEventsMap } from '@socket.io/component-emitter'
import io, { Socket } from 'socket.io-client'
import { API_HOST } from '../../constants'
import { fetchJwt } from '../../utils'

const socketOptions = {
  transports: ['websocket'],
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 10000,
  reconnectionAttempts: Infinity
}

let socket: Socket<DefaultEventsMap, DefaultEventsMap> | undefined

/**
 * Open (or re-open) the shared socket.
 *
 * Two things this guards that the previous version did not:
 *  - An existing socket is torn down first. Calling this twice used to leave
 *    the old connection open with all its listeners still attached, so events
 *    were handled once per stale socket.
 *  - The session JWT is sent in the handshake. The server authenticates the
 *    socket from that token rather than from the `userId` query parameter,
 *    which a client can set to anyone's id.
 */
export const connectSocket = (query: Record<string, unknown> = {}) => {
  disconnectSocket()

  socket = io(API_HOST, {
    ...socketOptions,
    auth: { token: fetchJwt() || undefined },
    query: query as Record<string, string>
  })

  return socket
}

export const disconnectSocket = () => {
  if (!socket) return

  socket.removeAllListeners()
  socket.disconnect()
  socket = undefined
}

export const getSocket = () => socket

export default io
